import script from "./TurnIntoDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./TurnIntoDropdown.vue?vue&type=script&setup=true&lang=js"

import "./TurnIntoDropdown.vue?vue&type=style&index=0&id=6614096d&lang=css"

const __exports__ = script;

export default __exports__